import styled from "styled-components";
import {down, up} from "styled-breakpoints";

export const Wrapper = styled.div`
    .cart-icons-line{
        margin: 16px 0;
        height: 1px;
        background-color: #F2F2F2;
    }
    ${up("md")} {
        padding-top: 70px;
    }
    ${down("md")} {
        .cart-icons-line{
            margin: 10px 0;
        }
    }
`